<template>

  <v-app id="inspire">
    <v-content>
      <v-container class="pa-0">


  <v-card>

    <v-row>
      <v-col>
        <template>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :custom-filter="filter"
            :items-per-page="20"
            class="ma-4"
            locale="ja-jp"
            loading-text="読込中"
            >

            <template v-slot:top>

              <v-toolbar flat color="white">
                <v-toolbar-title>介護記録一覧 - <span class="ym"> {{calday.year()}}年{{calday.month()+1}}月 </span></v-toolbar-title>

                <v-dialog v-model="dialog" fullscreen>

                  <v-toolbar dark dense>
                    <v-toolbar-title>実績＆テレッサ入力</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn @click="dialog = false">
                      <v-icon>close</v-icon> 閉じる
                    </v-btn>
                  </v-toolbar>

                  <v-card>

                    <v-card-text class="pa-2">
                      <v-container>
                        <v-row dense>
                          <v-col cols="12" xs="12" sm="6" md="6">
                            <v-text-field dense disabled v-model="editedItem.riname" label="利用者名"></v-text-field>
                          </v-col>
                          <v-col cols="12" xs="12" sm="6" md="6">
                            <v-text-field dense disabled v-model="editedItem.staffname" label="担当者名"></v-text-field>
                          </v-col>
                          <v-card width="100%" class="pa-4">
                            <v-card-title class="pa-0 pb-4" tile>実績入力(予定と違う場合のみ変更してください)</v-card-title>
                            <v-row dense>
                              <v-col cols="12" xs="12" sm="6" md="6">
                                <v-menu
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="editedItem.date"
                                      label="日付を選択してください"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      dense
                                      class="pt-1"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker dense v-model="editedItem.date" @input="menu = false" locale="ja"></v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field dense v-model="editedItem.kaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field dense v-model="editedItem.syuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>

                          <v-card width="100%" class="pa-4 mt-2" tile>
                            <v-card-title class="pa-0 pb-5">実績時間内訳</v-card-title>
                            <div class="overline mb-4">
                              <v-btn @click="jisseki" outlined>
                                <v-icon>file_copy</v-icon>直近の実績から簡単入力
                              </v-btn>
                            </div>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                身体介護時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.skaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.ssyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                家事支援時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.kkaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.ksyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                重度訪問時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.jkaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.jsyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                移動支援時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.ikaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field v-model="editedItem.isyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>

                          <v-card width="100%" class="pa-4 mt-2" tile>
                            <v-card-title class="pa-0 pb-2">テレッサ入力</v-card-title>
                            <v-row class="px-10">
                              <v-checkbox class="mr-2" v-model="editedItem.haisetu" label="排泄介助"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.syokuji" label="食事介助"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.ijo" label="移乗介助"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.kisyo" label="起床介助"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.mimamori" label="見守り"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.syusin" label="就寝介助"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.hukuyaku" label="服薬介助"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.nyuyoku" label="入浴介助"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.soji" label="掃除洗濯"></v-checkbox>
                              <v-checkbox class="mr-2" v-model="editedItem.kaimono" label="買物"></v-checkbox>
                            </v-row>
                            <v-row class="px-10">
                              <v-textarea
                                  solo
                                  name="input-7-4"
                                  v-model="editedItem.sonota"
                                  label="特記事項"
                                ></v-textarea>
                            </v-row>
                          </v-card>

                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="dialog = false">
                        <v-icon>close</v-icon> 閉じる
                      </v-btn>
                      <v-btn class="warning" @click="conf">確認画面へ</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="confdialog" fullscreen>

                  <v-toolbar dark dense>
                    <v-toolbar-title>確認画面</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn @click="confdialog = false">
                      <v-icon>close</v-icon> 閉じる
                    </v-btn>
                  </v-toolbar>

                  <v-card>

                    <v-card-text class="pa-2">
                      <v-container>
                        <v-row dense>
                          <v-col cols="12" xs="12" sm="6" md="6">
                            <v-text-field dense disabled v-model="editedItem.riname" label="利用者名"></v-text-field>
                          </v-col>
                          <v-col cols="12" xs="12" sm="6" md="6">
                            <v-text-field dense disabled v-model="editedItem.staffname" label="担当者名"></v-text-field>
                          </v-col>
                          <v-card width="100%" class="pa-4">
                            <v-card-title class="pa-0 pb-4" tile>実績入力</v-card-title>
                            <v-row dense>
                              <v-col cols="12" xs="12" sm="6" md="6">
                                <v-text-field dense disabled v-model="editedItem.date" label="日付"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field dense disabled v-model="editedItem.kaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field dense disabled v-model="editedItem.syuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>

                          <v-card width="100%" class="pa-4 mt-2" tile>
                            <v-card-title class="pa-0 pb-5">実績時間内訳</v-card-title>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                身体介護時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.skaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.ssyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                家事支援時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.kkaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.ksyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                重度訪問時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.jkaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.jsyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" xs="2" sm="2" md="2">
                                移動支援時間
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.ikaisi" type="time" step="900" label="開始"></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="6" sm="3" md="3">
                                <v-text-field disabled v-model="editedItem.isyuryo" type="time" step="900" label="終了"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>

                          <v-card width="100%" class="pa-4 mt-2" tile>
                            <v-card-title class="pa-0 pb-2">テレッサ入力</v-card-title>
                            <v-row class="px-10">
                              <v-checkbox disabled class="mr-2" v-model="editedItem.haisetu" label="排泄介助"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.syokuji" label="食事介助"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.ijo" label="移乗介助"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.kisyo" label="起床介助"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.mimamori" label="見守り"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.syusin" label="就寝介助"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.hukuyaku" label="服薬介助"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.nyuyoku" label="入浴介助"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.soji" label="掃除洗濯"></v-checkbox>
                              <v-checkbox disabled class="mr-2" v-model="editedItem.kaimono" label="買物"></v-checkbox>
                            </v-row>
                            <v-row class="px-10">
                              <v-textarea
                                  solo
                                  name="input-7-4"
                                  v-model="editedItem.sonota"
                                  label="特記事項"
                                  readonly
                                ></v-textarea>
                            </v-row>
                          </v-card>

                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <span style="color:red;">入力内容に間違いがなければ保存ボタンを押してください</span>
                      <v-spacer></v-spacer>
                      <v-btn @click="open">
                        <v-icon>undo</v-icon> 戻る
                      </v-btn>
                      <v-btn class="success" @click="save">保存</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>




              </v-toolbar>
              <v-toolbar flat>
                <v-col>
                  <div id="calendar-nav" style="width:180px;">
                    <v-btn class="glyphicon glyphicon-menu-left" @click="moveLastMonth()">
                      <v-icon>keyboard_arrow_left</v-icon>前月
                    </v-btn>
                    
                    <v-btn class="glyphicon glyphicon-menu-right"  @click="moveNextMonth()">
                      次月<v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </div>
                </v-col>

                <v-card>
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="検索"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                </v-card>
              </v-toolbar>


            </template>


            <template v-slot:item.sien="{ item }">

              {{ formatDate(item.date) }} 
              {{ item.riname }}
              {{ item.kaisi }} - 
              {{ item.syuryo }}
              {{ item.staffname }}

            </template>


            <template v-slot:item.jisseki="{ item }">

              <v-btn
                depressed
                @click="editItem(item)"
                color="warning"
                class="mb-2"
                small
                v-if="chkJisseki(item) == 'upd'"
                >修正可能
                <v-icon dark right>edit</v-icon>
              </v-btn>

              <v-btn
                depressed
                color="success"
                small
                class="mb-2"
                v-if="chkJisseki(item) == 'cmt'"
                >入力確定
                <v-icon dark right>check_box</v-icon>
              </v-btn>

              <v-btn
                depressed
                @click="editItem(item)"
                color="primary"
                v-if="chkJisseki(item) == 'ins'"
                class="mb-2"
                small
                >実績＆テレッサ入力
                <v-icon dark right>create</v-icon>
              </v-btn>

            </template>

            <template v-slot:no-data>
            </template>
          </v-data-table>
        </template>

        <v-snackbar
          v-model="snackbar"
          color="info"
          :timeout=1000
        >
          {{ msg }}

        </v-snackbar>
      </v-col>
    </v-row>
    
  </v-card>



    </v-container>
  </v-content>
</v-app>
</template>

<script>
import Common from '@/components/Common'
import moment from 'moment'

export default {
  mixins: [ Common ],
  data: () => ({
    dialog: false,
    confdialog: false,
    headers: [
      { text: '支援', value: 'sien', width: '200px', filterable: true},      
      { text: '実績入力', value: 'jisseki', width: '100px', ortable: false},
    ],
    items: [],
    menu: false,
    search: '',
    editedIndex: -1,
    editedItem: {
      skaisi: '',
      ssyuryo: '',
      kkaisi: '',
      ksyuryo: '',
      jkaisi: '',
      jsyuryo: '',
      ikaisi: '',
      isyuryo: '',
      
    },
    defaultItem: {
      riname: '',
      hyoji: 0
    },
    calday: moment().date(1),
    caldata: [],
    msg: '',
    snackbar: '',
    services: []
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '新規追加' : '編集'
    }
  },

  watch: {
    editedItem: {
      handler: function () {
      },
      deep: true
    },
  },

  created () {
    this.kousin()
  },

  mounted () {
    moment.lang('ja');
    this.getServices()
  },

  methods: {

    filter (value, search, item) {
      var text = item.date + item.riname + item.kaisi + item.syuryo + item.staffname
      if (text.indexOf(search) != -1) return item
    },
    formatDate: function (date) {
      return moment(date).format('MM/DD (ddd)')
    },
    moveLastMonth: function () {
      this.keyid = 0
      this.calday.add(-1, 'months')
      this.kousin()
    },
    moveNextMonth: function () {
      this.keyid = 0
      this.calday.add(1, 'months')
      this.kousin()
    },
    getServices () {
      this.$axios.get(this.url + 'getServices.php')
        .then((response) => {
          this.services = response.data
        })
    },
    jisseki () {
      var self = this
      this.$axios.post(this.url + 'getJisseki.php', JSON.stringify({
        kaisi: this.editedItem.kaisi,
        syuryo: this.editedItem.syuryo,
        rid: this.editedItem.riid,
        staffid: this.editedItem.staffid,
        id: this.$store.getters.auth.id,
        jid: this.editedItem.jid,
      })).then(function (res) {
        if (res.data.length != 0) {
          var kantan = res.data[0]
          self.$set(self.editedItem, "skaisi", kantan.skaisi)
          self.$set(self.editedItem, "ssyuryo", kantan.ssyuryo)
          self.$set(self.editedItem, "kkaisi", kantan.kkaisi)
          self.$set(self.editedItem, "ksyuryo", kantan.ksyuryo)
          self.$set(self.editedItem, "jkaisi", kantan.jkaisi)
          self.$set(self.editedItem, "jsyuryo", kantan.jsyuryo)
          self.$set(self.editedItem, "ikaisi", kantan.ikaisi)
          self.$set(self.editedItem, "isyuryo", kantan.isyuryo)
          self.$set(self.editedItem, "haisetu", kantan.haisetu)
          self.$set(self.editedItem, "syokuji", kantan.syokuji)
          self.$set(self.editedItem, "ijo", kantan.ijo)
          self.$set(self.editedItem, "kisyo", kantan.kisyo)
          self.$set(self.editedItem, "mimamori", kantan.mimamori)
          self.$set(self.editedItem, "syusin", kantan.syusin)
          self.$set(self.editedItem, "hukuyaku", kantan.hukuyaku)
          self.$set(self.editedItem, "nyuyoku", kantan.nyuyoku)
          self.$set(self.editedItem, "soji", kantan.soji)
          self.$set(self.editedItem, "kaimono", kantan.kaimono)
          self.$set(self.editedItem, "sonota", kantan.sonota)
        }
      })
    },
    kousin () {
      var self = this
      this.$axios.post(this.url + 'shift.php', JSON.stringify({
        kaisi: moment(this.calday).format('YYYY-MM-DD'),
        syuryo: moment(this.calday).add(1, 'months').format('YYYY-MM-DD'),
        today: '',
        order: 'hiduke',
        id: this.$store.getters.auth.id,
        role: this.$store.getters.auth.role
      })).then(function (res) {
        self.items = res.data
      })
    },
    editItem (item) {
      this.editedItem = item
      if (this.chkJisseki(item) == 'upd') this.jisseki()
      // this.editedIndex = this.items.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      confirm('削除してもよろしいですか？') && this.items.splice(index, 1)
      var self = this
      this.$axios.post(this.url + 'user.php', JSON.stringify({
        st: 'del',
        item: item
      })).then(function () {
        self.msg = '削除完了しました。'
        self.snackbar = true
        self.kousin()
        self.close()
      })
    },
    open () {
      this.confdialog = false
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    conf () {
      this.dialog = false
      this.confdialog = true
    },
    confclose () {
      this.confdialog = false
    },
    chkJisseki (item) {
      if (item.jid == null) {
        return 'ins'
      } else if (item.jid != '') {
        if (moment().diff(moment(item.jcd), "minute") < 120) {
          return 'upd'
        } else {
          return 'cmt'
        }
      }
      return false
    },
    save () {
      var status = this.chkJisseki(this.editedItem)
      // if (this.chkJisseki(this.editedItem) != 'ins') status = 'upd'
      this.editedItem.updid = this.$store.getters.auth.id
      var self = this
      this.$axios.post(this.url + 'updateJisseki.php', JSON.stringify({
        st: status,
        item: this.editedItem
      })).then(function () {
        self.msg = '登録完了しました。'
        self.snackbar = true
        self.kousin()
        self.close()
        self.confclose()
      })
    }
  }
}
</script>

<style lang="stylus" scope>
  .application {
  }
  .container {
    padding 2
  }
 :disabled { color: #000000 !important; } 

  .hide {
    display: none;
  }

  .v-data-table__mobile-row {
    min-height 25px !important
  }
 
</style>
